export enum AllowListType {
  Event = "event",
  User = "user",
  Group = "group",
}

export type AllowList = string[];
